import { defineTopic } from 'magpie-lib/models';
import { assistantPublishMessage, assistantTopicFilter } from '../messages/assistantPublishMesage';
import { streamingPublishMessage } from '../messages/streamingPublishMessage';
import { streamEventPublishMessage } from '../messages/streamEventPublishMessage';
const ASSISTANT_TOPIC = 'ASSISTANT_TOPIC';
export const AssistantTopicDef = defineTopic({
  name: ASSISTANT_TOPIC,
  messages: [assistantPublishMessage, streamingPublishMessage, streamEventPublishMessage],
  enableRuntimeValidation: false,
  audience: assistantTopicFilter
});